// extracted by mini-css-extract-plugin
module.exports = {"toolbarMenuIconItem":"toolbarMenuIconItem--3K2ed","localeTabPane":"localeTabPane--2Wa9_"};